import { ProgressSpinner } from "primereact/progressspinner";

export default function ProfileLoadingComponent() {
  return (
    <div className="flex justify-center items-center h-screen bg-gradient-to-b from-slate-950 via-fuchsia-950 to-gray-950">
      <ProgressSpinner strokeWidth="3" animationDuration=".5s" className="chat-loading-spinner" />
    </div>
  );
}
